__turbopack_context__.v({
  "article": "Steps-module__8tvS-G__article",
  "articles": "Steps-module__8tvS-G__articles",
  "description": "Steps-module__8tvS-G__description",
  "root": "Steps-module__8tvS-G__root",
  "step": "Steps-module__8tvS-G__step",
  "title": "Steps-module__8tvS-G__title",
});
